export default {
  views: {
    login: {
      subtitle: '団体予約お申込みサイト'
    }
  }
};
